import Usuario from "model/administracao/cadastro/Usuario";
import { BaseModel } from "model/BaseModel";
import ItemClasseAuditoria from "./ItemClasseAuditoria";

export default class AcaoAuditoria implements BaseModel {
    id: number;
    codigo: string | null;
	status: string;
    nome: string;
	descricao: string;
    resposta: string;
	itemAuditoria: ItemClasseAuditoria;
	responsavel: Usuario|null;
    dataLimite: Date | null;
    createdAt: Date | null;

    constructor(
        id = 0,
        codigo = null,
        status = '',
        nome = '',
        descricao = '',
        resposta = '',
        itemAuditoria = new ItemClasseAuditoria(),
        responsavel = null,
        dataLimite = null,
        createdAt = null
    ){ 
        this.id = id;
        this.codigo = codigo;
        this.status = status;
        this.nome = nome;
        this.descricao = descricao;
        this.resposta = resposta;
        this.itemAuditoria = itemAuditoria;
        this.responsavel = responsavel;
        this.dataLimite = dataLimite;
        this.createdAt = createdAt;
    }
}